export const MAINTENANCE_CHECK_MAINTENANCE_REQUEST = 'APPLICATION/CHECK-MAINTENANCE/REQUEST';
export const MAINTENANCE_CHECK_MAINTENANCE_RECEIVED = 'APPLICATION/CHECK-MAINTENANCE/RECEIVED';
export const MAINTENANCE_CHECK_MAINTENANCE_ERROR = 'APPLICATION/CHECK-MAINTENANCE/ERROR';
